// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2sTFv","footer":"ModalInfo_footer__1-t_b"};